import React from 'react'
import PropTypes from 'prop-types';
import GridBlock from './GridBlock';
import Chip from './Chip';
import Tr from 'translations/Translations';
import downloadFile from "../libs/downloadFile";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import {DraftsOutlined, MailOutline} from '@material-ui/icons';
import TooltipIcon from "./icon/TooltipIcon";
import {makeStyles} from "@material-ui/core";
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    blackChipIcon: {
        '& svg': {
            color: theme.palette.text.primary
        }
    }
}));

function FilesList(
    {
        elements = [],
        onDelete,
        customAction,
        onDownload,
        showDownloadDate = false
    }) {

    const classes = useStyles();
    return (<GridBlock spacing={1}>
        {elements.map((element, i) => {
            const {file} = element;
            return (
                <Chip
                    className={clsx({[classes.blackChipIcon]: showDownloadDate})}
                    value={file.name}
                    onDelete={onDelete ? ()=> onDelete(i) : undefined}
                    onClick={() => !!onDownload ? onDownload(element) : downloadFile(file) }
                    key={i}
                    tooltip={Tr('download')}
                    disabled={element.inaccessible}
                    customDeleteIcon={!!showDownloadDate ?
                        <TooltipIcon Icon={!!element.firstDownloadDate ? DraftsOutlined : MailOutline}
                                     tooltip={!!element.firstDownloadDate ? `${Tr('file_downloaded')}: ${moment(element.firstDownloadDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT)}` : Tr('file_not_downloaded')}/>
                        : undefined
                    }
                />
            )
        })}
        {customAction}
    </GridBlock>)
}

FilesList.propTypes = {
    classes: PropTypes.any,
    elements: PropTypes.array,
    onDelete: PropTypes.func,
    onDownload: PropTypes.func,
    customAction: PropTypes.any
};

export default FilesList;